<div class="pcmso-container">
    @if (carregando()) {
        <div class="feedback">Carregando dados...</div>
    } @else if (erroConsulta()) {
        <div class="feedback erro">{{ erroConsulta() }}</div>
    } @else if (!dados()) {
        <div class="feedback">Nenhum dado disponível para este protocolo.</div>
    } @else {
        <div class="secoes">
            @for (secao of secoes; track secao.titulo) {
                <app-card-content [headerColor]="false" [title]="secao.titulo" [icon]="iconeDaSecao(secao.titulo)" [subtitle]="subtituloDaSecao(secao.titulo)">
                    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                        @for (campo of secao.campos; track campo.label) {
                            <ng-container [ngTemplateOutlet]="campoDaSecao" [ngTemplateOutletContext]="{ secao: secao, campo: campo }" />
                        }
                    </div>
                </app-card-content>
            }

            <app-card-content [headerColor]="false" [title]="'Anexo'" [icon]="iconeDaSecao('Anexo')" [subtitle]="subtituloDaSecao('Anexo')">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <article class="campo campo--anexo">
                        <span class="campo-label">Anexo Documento</span>
                        @if (possuiAnexo()) {
                            <button type="button" class="campo-link-botao" (click)="onVisualizarAnexo($event)" aria-label="Visualizar anexo" title="Visualizar anexo">
                                <i class="pi pi-paperclip"></i>
                                <span>Visualizar anexo</span>
                            </button>
                        } @else {
                            <strong class="campo-valor">-</strong>
                        }
                    </article>
                </div>
            </app-card-content>
        </div>
    }
</div>

<!--
    Um campo, nas duas formas — o mesmo desenho do detalhamento de consultório privado.

    `secaoEhDeDados` (vocabulário compartilhado) decide a forma. Nas seções de dados o campo sai como controle DESABILITADO:
    é a aparência do detalhamento de pré-prestador, e desabilitado porque esta tela é de leitura —
    campo habilitado prometeria uma edição que não existe aqui.

    `for`/`id` ligam rótulo e controle (o id junta seção e rótulo, que se repetem entre seções). Em
    "Protocolo", que segue como texto, o par continua sendo `campo-label`/`campo-valor` e a situação
    mantém o badge que a colore.
-->
<ng-template #campoDaSecao let-secao="secao" let-campo="campo">
    @if (secaoEhDeDados(secao.titulo)) {
        <div class="field">
            <label class="font-semibold block mb-2" [for]="idDoCampo(secao, campo)">{{ campo.label }}</label>
            <input pInputText [id]="idDoCampo(secao, campo)" class="w-full" [value]="valorCampo(campo)" disabled />
        </div>
    } @else {
        <article
            class="campo"
            [class.campo--destaque-identificacao]="campo.label.toLowerCase().trim().startsWith('cpf') || campo.label.toLowerCase().trim().startsWith('crm') || campo.label.toLowerCase().includes('cnpj')"
            [class.campo--situacao]="ehCampoBadge(campo)"
        >
            <span class="campo-label">{{ campo.label }}</span>
            @if (ehCampoBadge(campo)) {
                <span [class]="'campo-badge situacao-' + situacaoClassePorTexto(valorCampo(campo))">
                    {{ rotuloBadgeSituacao(campo.label, valorCampo(campo)) }}
                </span>
                @if (protocoloSelecionado()?.inPago === false) {
                    <span class="campo-badge campo-badge-pagamento nao-pago">Não pago</span>
                }
            } @else {
                <strong class="campo-valor">{{ valorCampo(campo) }}</strong>
            }
        </article>
    }
</ng-template>

<p-dialog
    appDialogoPadrao="pi pi-paperclip"
    descricao="Documento anexado ao registro."
    [visible]="exibirDialogAnexo()"
    (visibleChange)="exibirDialogAnexo.set($event)"
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    header="Visualização de anexo"
    (onHide)="fecharDialogAnexo()"
>
    @if (blobAnexo(); as blobAnexo) {
        <app-visualizador-pdf [src]="blobAnexo" [fileName]="nomeArquivoAnexo()" [showAll]="false"></app-visualizador-pdf>
    } @else {
        <div class="feedback">Nenhum anexo disponível para visualização.</div>
    }
</p-dialog>
